export default __webpack_public_path__ + "static/media/monstera-full.4be81b2b.png";